// import { EmptyStateLayout } from '@panwds/react-ui'
import RCTree from '../page/rcTree/RCTree'
import NoDataScreen from '../noDataScreen/NoDataScreen'
import { LABEL_NO_ACCESS, LABEL_NO_ACCESS_DESCRIPTION } from '../../constants/LabelConstants'

const NoAccess = (props) => {
  const { selectedTreeNode } = props
  return (
    <div className='tw-flex tw-flex-row tw-flex-1 tw-absolute tw-inset-0 tw-overflow-hidden'>
      <div className='common-module-side-bar dark:cm-bg-gray-950'>
        <RCTree
          {...props}
          expandedKeys={[selectedTreeNode?.parent_id]}
          showContextButton={false}
        />
      </div>
      <NoDataScreen heading={LABEL_NO_ACCESS} description={LABEL_NO_ACCESS_DESCRIPTION} />
    </div>
  )
}

export default NoAccess
